import React from 'react';
import {
  Container, Typography, Grid, Card, CardContent, Box, List,
  ListItem, ListItemIcon, ListItemText, Paper, Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloudIcon from '@mui/icons-material/Cloud';
import EmailIcon from '@mui/icons-material/Email';
import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';

const services = [
  'Microsoft 365 setup and administration',
  'Exchange Online email configuration',
  'SharePoint and Teams deployment',
  'Azure Active Directory (Entra ID) management',
  'Hybrid AD (on-prem + Azure AD sync)',
  'Microsoft Intune / Endpoint Manager',
  'User account provisioning and management',
  'Email migration to Microsoft 365',
  'Conditional access and MFA setup',
  'Microsoft 365 license management',
  'OneDrive for Business configuration',
  'Security and compliance policies',
];

const benefits = [
  {
    icon: CloudIcon,
    title: 'Azure & M365 Expert',
    description: 'Hands-on experience managing Microsoft 365 and Azure across enterprise environments',
  },
  {
    icon: EmailIcon,
    title: 'Exchange & Teams',
    description: 'Full deployment and administration of Exchange Online, SharePoint, and Teams',
  },
  {
    icon: GroupIcon,
    title: 'Hybrid AD Sync',
    description: 'Seamless integration between on-premises Active Directory and Azure AD',
  },
  {
    icon: SecurityIcon,
    title: 'Secure Configuration',
    description: 'Conditional access, MFA, and compliance policies to protect your organization',
  },
];

function Microsoft365Cloud() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h2" component="h1" className="gradient-text" sx={{ mb: 3 }}>
            Microsoft 365 & Azure Cloud
          </Typography>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 4 }}>
            Professional setup and administration of Microsoft 365, Azure, and hybrid cloud environments
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2, px: 4, fontSize: '1.2rem',
              background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
              '&:hover': { background: 'linear-gradient(45deg, #3b82f6 30%, #2563eb 90%)' }
            }}
          >
            Schedule Consultation
          </Button>
        </Box>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card className="glass-effect card-hover" sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>{benefit.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{benefit.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Paper elevation={3} sx={{ p: 4, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>What's Included</Typography>
          <Grid container spacing={2}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default Microsoft365Cloud;
